import { Box, Button } from "@mui/material";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useApiMutation } from "src/hooks/useApiMutation";
import MoneyReceiptForm from "./MoneyReceiptForm";
import type { ICreateMoneyReceipt } from "./type/moneyReceiptType";
import type { SingleExhibitorInvoiceInfo } from "../type/exhibitorType";

interface IProps {
	handleClose: () => void;
	invoiceDetails?: SingleExhibitorInvoiceInfo;
}

const CreateMoneyReceipt = ({ handleClose, invoiceDetails }: IProps) => {
	const {
		mutate: createMoneyReceipt,
		isPending,
		isSuccess,
	} = useApiMutation<ICreateMoneyReceipt, void>({
		method: "POST",
		endPoint: "/api/admin/exhibitor/money-receipt",
		invalidateQueries: ["money-receipt", "singleInvoice"],
	});
	const { control, register, handleSubmit, watch } = useForm<any>({
		defaultValues: {
			payment_date: dayjs().format("YYYY-MM-DD"),
		},
	});
	const onSubmit = (formData: ICreateMoneyReceipt) => {
		if (invoiceDetails?.id && invoiceDetails?.exhibitor_id) {
			formData.invoice_id = invoiceDetails?.id;
			formData.exhibitor_id = invoiceDetails?.exhibitor_id;
		}

		createMoneyReceipt(formData);
	};

	useEffect(() => {
		if (isSuccess) {
			handleClose();
		}
	}, [isSuccess]);

	return (
		<Box
			component='form'
			onSubmit={handleSubmit(onSubmit)}
			sx={{ p: 2, mt: 1 }}
		>
			<MoneyReceiptForm
				register={register}
				watch={watch}
				control={control}
				invoiceDetails={invoiceDetails}
			/>

			<Button
				type='submit'
				fullWidth
				variant='contained'
				sx={{ mt: 3 }}
				disabled={isPending}
			>
				Create Money Receipt
			</Button>
		</Box>
	);
};

export default CreateMoneyReceipt;
